export const FIELD_NAMES = {
  INDUSTRY: 'industry'
};
